import { BENCHMARKS_CHART_COLORS } from '../../components/dashboard/Views/config/benchmarksCards';

const state = {
  brandData: undefined,
  categoryData: undefined,
  activeBenchmarksView: 'category',
};

const mutations = {
  updateBenchmarksBrandData(state, data) {
    state.brandData = data;
  },
  updateBenchmarksCategoryData(state, data) {
    state.categoryData = data;
  },
  updateActiveBenchmarksView(state, view) {
    state.activeBenchmarksView = view;
  },
};

const getters = {
  benchmarksColors(state) {
    return BENCHMARKS_CHART_COLORS[state.activeBenchmarksView];
  },
  benchmarksChartKeys({ activeBenchmarksView }, { uniqueBenchmarkCategoryKeys }) {
    const isCategoryView = activeBenchmarksView === 'category';
    const secondaryValue = isCategoryView ? 'category' : 'comparison';
    const chartKeys = [
      { name: 'primary', value: 'base' },
      { name: 'secondary', value: secondaryValue },
    ];

    // Subcategories are optional and their keys won't always need to be displayed.
    // We only want to include these keys when they exist in the category data response
    if (isCategoryView) {
      if (uniqueBenchmarkCategoryKeys?.has('subcategoryOne')) {
        chartKeys.push({ name: 'tertiary', value: 'subcategoryOne' });
      }

      if (uniqueBenchmarkCategoryKeys?.has('subcategoryTwo')) {
        chartKeys.push({ name: 'quaternary', value: 'subcategoryTwo' });
      }

      if (uniqueBenchmarkCategoryKeys?.has('subcategoryThree')) {
        chartKeys.push({ name: 'quinary', value: 'subcategoryThree' });
      }
    }

    return chartKeys;
  },
  uniqueBenchmarkCategoryKeys({ categoryData = {} }) {
    return new Set(
      Object.values(categoryData)
        .map(({ benchmarks = [] }) => benchmarks)
        .flat()
        .flatMap((benchmarksObj = {}) => Object.keys(benchmarksObj)),
    );
  },
};

export const benchmarksModule = {
  state,
  mutations,
  getters,
};
